<template>
  <section class="bg-white">
    <div
      class="gap-16 items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:py-16 lg:px-6"
    >
      <div class="font-light text-gray-500 sm:text-lg">
        <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
          Manege frei und herzlich willkommen!
        </h2>
        <p class="mb-4">
          Vom 18.7. bis zum 27.7.25 ist es wieder so weit: Zum 11. Mal heißt es
          nun schon: Manege frei und herzlich willkommen im Circus St. Ottilien!
        </p>
        <p>
          Nach dreijähriger Pause lädt das Rhabanus-Maurus-Gymnasium in St.
          Ottilien erneut zu seinem einzigartigen Schul- und Klostercircus ein.
          Auch in seiner elften Auflage begeistert unsere Schule mit
          beeindruckenden Darbietungen wie Boden- und Luftakrobatik, Jonglage,
          Clownerie und vielem mehr. Zusätzlich erwarten Sie Bewirtung und
          Unterhaltung auf unserem Jahrmarkt. Wir freuen uns auf euch!
        </p>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-8">
        <img
          width="500"
          height="500"
          class="w-full rounded-lg mt-10"
          src="/media/images/about_1.webp"
          alt="Person die eine brennende Fackel schwinkt"
        />
        <img
          width="500"
          height="500"
          class="w-full rounded-lg"
          src="/media/images/about_2.webp"
          alt="Zwei Personen bei der Luftakrobatik"
        />
      </div>
    </div>
  </section>
</template>
